import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				let savePost=false
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						
						case 'guardarFtn':	

							await this.updateDataForm({ state: 'afiliado_documentos/id_datos_afiliado', data: this.searchSw.value})
							await this.updateDataForm({ state: 'afiliado_documentos/id_afiliacion_registro', data: this.searchsGet.id})
							
							// configurar dataPost
							if(event.save===false)
							{
								
								await this.updateDataPost({ state: 'data', data:  []})
							}
							
							await this.updateDataPost({ state: 'route', data:   'save_all'})
							await this.updateDataPost({ state: 'tablaPost', data:  ['afiliado_documentos','subir_archivos']})
							await this.updateDataPost({ state: 'tablaDelete', data:  []})

						break;
						case 'tablePostGuardarFtn': 
							savePost=true
						break;	
					}
				}

				await this.save(event.save,savePost)

				if(event.save===false)
				{
					await this.resetCrud({state: 'searchSw'})
				}					
				await this.resetFile()				
				await this.resetDataIndex()
				await this.resetGlobal({state: 'openModal'})
				await this.resetDataForm()	
				await this.updateDataForm({state: 'subir_archivos', data: []})			
				await this.resetGlobal({state: 'saveConfig/capa'}) 
			}
			catch{

			}			
		}		
	},
}
